import {
  Button,
  ButtonProps,
  HStack,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalOverlay,
  Text,
  useDisclosure,
  VStack,
} from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { TrackOrderInterface } from "../../constants/TrackOrder";
import useCustomToast from "../../lib/useCustomToast";
import { getAxiosInstance } from "../../utils/helperFunction";
import { CardSkeleton } from "../skeleton/CardSkeleton";
import { TrackOrderStepper } from "./TrackOrderStepper";

interface Props extends ButtonProps {
  pageType: number;
  id: any;
  resi: string;
}

export const TrackOrderModal = ({ pageType, id, resi, ...rest }: Props) => {
  const [data, setData] = useState<TrackOrderInterface | undefined>(undefined);
  const [loaded, setLoaded] = useState<boolean>(false);

  const toast = useCustomToast();
  const { isOpen, onOpen, onClose } = useDisclosure();

  useEffect(() => {
    if (isOpen) {
      const axiosInstance = getAxiosInstance(pageType);

      let userType: string = "buyer";

      if (pageType === 2) {
        userType = "reseller";
      } else if (pageType === 3) {
        userType = "supplier";
      }

      axiosInstance
        .get(`/v1/${userType}/purchase-track/${id}`)
        .then((res) => {
          setData(res.data.data);
        })
        .catch((err) => {
          toast({
            description: err?.response?.data?.message || "",
          });
        })
        .finally(() => {
          setLoaded(true);
        });
    }
  }, [isOpen, resi, id, pageType]);

  const copyResi = () => {
    navigator.clipboard.writeText(resi);

    toast({
      title: "Resi disalin",
      status: "success",
    });
  };

  return (
    <>
      <Button
        size={["xs", null, "sm"]}
        variant={"outline"}
        colorScheme="red"
        onClick={onOpen}
        {...rest}
      >
        Lacak Pesanan
      </Button>

      <Modal
        scrollBehavior="inside"
        size={"xl"}
        isOpen={isOpen}
        onClose={onClose}
      >
        <ModalOverlay />

        <ModalContent>
          <ModalCloseButton />

          <ModalBody>
            <VStack w={"100%"} mb={8} align={"stretch"}>
              <VStack w={"100%"} p={4} gap={0} textAlign={"center"}>
                <Text textStyle={"h-reg-title"}>Lacak Pesanan</Text>
                <HStack cursor={"pointer"} onClick={copyResi}>
                  <Text textStyle={"b-sm"} variant={"secondary"}>
                    {`Nomor Resi: ${resi}`}
                  </Text>
                </HStack>
              </VStack>

              {!loaded ? (
                <CardSkeleton row={1} column={10} height={30} />
              ) : (
                <TrackOrderStepper data={data?.info.history} />
              )}
            </VStack>
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
};
